import { useSessao } from '../lib/sessao'
import { Topo } from '../componentes/ui'
import { AbaProcedimentos } from './PecasCadastro'
import { SecaoEspecialidades } from './ConfigSecoes'
import { PacotesCatalogo } from './PacotesCatalogo'

/**
 * O que a clínica faz, e por quanto.
 *
 * Era o grupo "catálogo" de `/ajustes`. Vira destino porque o
 * procedimento é o que define **duração e preço** de cada horário: sem
 * nenhum cadastrado, `POST /v1/agendamentos` não tem
 * `procedimento_id` para receber, e a agenda simplesmente não aceita
 * marcação.
 *
 * Especialidade vem DEPOIS do procedimento, e não antes: ela é filtro
 * de quem pode fazer o quê, e filtro sem lista para filtrar não diz
 * nada a quem está montando a clínica.
 */
export function Catalogo() {
  const { pode } = useSessao()
  const podeEditar = pode('config:write')
  return (
    <>
      <Topo titulo="Catálogo"
            subtitulo="O que a clínica oferece. Cada procedimento carrega a duração e o preço que a agenda usa.">
        {!podeEditar && <span className="selo selo--neutro">só leitura</span>}
      </Topo>
      <AbaProcedimentos podeEditar={podeEditar} />
      {/* Pacote vem logo depois do procedimento porque se apoia nele:
          "10 sessões de fisioterapia" só existe se "fisioterapia"
          existir. Antes das especialidades, que são filtro. */}
      <PacotesCatalogo podeEditar={podeEditar} />
      <SecaoEspecialidades podeEditar={podeEditar} />
    </>
  )
}
